export const DocumentUploadRequestSentEventName = "DocumentUploadRequestSent";

export type DocumentUploadRequestSentEventData = {
    episodeId: string;
};
